module.exports = __webpack_public_path__ + "img/name.7b8fe745.png";